import { gql } from '@apollo/client';

export const GET_ALL_INVESTMENTS = gql`
  query GetAllInvestments($input: GetAllInvestmentsInput) {
    getAllInvestments(input: $input) {
      statusCode
      message
      total
      investments {
        id
        customer {
          id
          name
          email
        }
        asset {
          assetId
          name
          type
          # Which network the tokens were delivered on. An admin reconciling a mint needs
          # this to know which explorer the hash belongs to.
          chain
        }
        totalAmount
        status
        compliance {
          ready
          blockedStatus
          reason
          applicable
        }
        isCrypto
        projectedNumberOfTokens
        tokensAllocated
        paymentReference
        transactionHash
        # Built by the API, on the settlement chain — transactionHash is the USDC transfer,
        # which is mined on Polygon even when the tokens are delivered elsewhere.
        explorerUrl
        docusignEnvelopeId
        # The investor's accredited-investor letter (one per investor) and its status.
        accreditationEnvelopeId
        accreditationStatus
        # The investor's ACE accredited-investor credential (once per investor).
        accreditationAceStatus
        # The admin's approve/deny of the accreditation (null = not reviewed yet).
        accreditationReviewStatus
        # On-chain InvestmentRecordRegistry write for this investment.
        registryStatus
        registryTxHash
        # The investor's active wallet, shown in the list.
        customerWalletAddress
        # 5-day token reservation (ACTIVE / SECURED / RELEASED).
        reservationStatus
        reservedAt
        reservationExpiresAt
        reservationSecuredAt
        reservationReleasedAt
        updatedAt
        expiresAt
        completedAt
      }
    }
  }
`;
